import * as api from "@/api/give-course/index";
import * as TYPES from "./type";

export default {
  //授课首页
  async getSKCourseList({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKCourseList(paramets);
    commit(TYPES.SK_COURSE_LIST, { result });
    cb && cb();
  },
  //打开手写板
  async getOpenPad({ commit, state }, { paramets, cb }) {
    const result = await api.reqOpenPad(paramets);
    commit(TYPES.SK_OPEN_PAD, { result });
    cb && cb();
  },
  //获取评分类型
  async getEvaluateType({ commit, state }, { paramets, cb }) {
    const result = await api.reqEvaluateType(paramets);
    commit(TYPES.SK_EVALUATE_TYPE, { result });
    cb && cb();
  },
  //添加教室
  async addClassroom({ commit, state }, { paramets, cb }) {
    const result = await api.reqAddClassroom(paramets);
    commit(TYPES.SK_OPEN_PAD, { result });
    cb && cb();
  },
};
